module.exports = require("@swa-ui/dotcom/src/DotcomFooter/DotcomDesktopFooter/DotcomDesktopFooter.module.scss");